import useSWR from 'hooks/useSWR';

export default id =>
  useSWR({ url: `/v4/fave_payments/${id}`, swrOptions: { if: Boolean(id) } });
